<template>
  <div>
    <v-layout justify-center align-center row wrap class="splash">
      <v-flex class="custom-font splash-content ml-5 pa-5" style="height: 100%;">
        <div class="fade-in-text caos-font">Chuteout</div>
        <div class="fade-in-text caos-font">Action</div>
        <div class="fade-in-text caos-font">Obsessed</div>
        <div class="fade-in-text caos-font">Sports</div>
        <v-btn to="/suits" large variant="outlined" v-ripple
          class="mt-5 white--text elevation-2 custom-font fade-in-text btn-gradient-2">
          Shop Custom Suits Now
        </v-btn>
      </v-flex>
      <v-flex class="hidden-sm-and-down pr-5 mr-4">
        <!-- <v-img v-ripple class="mb-2 mr-3 fade-in-image" style="opacity: 40%;" src="https://storage.googleapis.com/caos-suits-v2/skulllogo6.svg"/> -->
        <v-img class="fade-in-image" style="opacity:100%;" src="https://storage.googleapis.com/caos-suits-v2/Hero.png" />
      </v-flex>
    </v-layout>
    <section class="py-5">
      <v-layout row wrap>
        <v-flex class="pa-3" v-for="item in testimonials" :key="item.id" xl6 sm6 lg6 xs12>
          <v-card style="height: 100%">
            <v-layout justify-center row wrap>
              <v-avatar class="mb-3 mt-4" :tile="false" :size="100" color="grey lighten-4">
                <img :src="getImage(item)" :alt="item.name" />
              </v-avatar>
              <div>
                <h2 class="px-5 py-2 subheading font-weight-medium">{{ item.text }}</h2>
                <p class="mt-4 text-xs-center title">- {{ item.name }} -</p>
              </div>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </section>

    <section class="pricing"></section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      testimonials: [
        {
          id: 0,
          image: "jaymartin.jpg",
          name: "Jay Martin",
          text:
            " I've purchased two suits from Caos and will definitely get more. Awesome guy, quick and reliable service, and unbeatable prices. Did I mention they were delivered within 30 days? So measurements, stitching it all together, and shipping from across the pond all within 30 days. Amazing. Thanks!",
        },
        {
          id: 1,
          image: "mikeberterant.png",
          name: "Mike Berterant",
          text:
            "Very impressive customer service experience with CAOS. I had a problem with my order and contacted Heath directly. He refunded the purchase immediately and addressed the issue like a champ! Very personable and stand-up service, cheers!",
        },
        {
          id: 2,
          image: "johnashcraft.jpg",
          name: "John Ashcraft",
          text:
            "Can't say enough good things about my Caos suit! Heath has fantastic customer service, the freefly suit flies AMAZING in the sky and tunnel. Very well made, and quick turn around. Will be ordering another soon!",
        },
        {
          id: 3,
          image: "nickbeyel.jpg",
          name: "Nick Beyel",
          text:
            "I purchased my first suit, the hybrid, from Caos and couldn't be happier with it. The fit was excellent, the custom print was easy to order, and the suit turned out amazing. Even after asking for a shipping address change, the order came quickly. Great customer service! Will definitely be ordering more in the near future.",
        },
      ],
      herourls: [
        {
          id: 0,
          url: "https://storage.googleapis.com/caos-suits-v2/Home/hero1.JPG",
        },
        {
          id: 1,
          url: "https://storage.googleapis.com/caos-suits-v2/Home/hero3.PNG",
        },
        {
          id: 2,
          url: "https://storage.googleapis.com/caos-suits-v2/Home/hero4.PNG",
        },
        {
          id: 3,
          url: "https://storage.googleapis.com/caos-suits-v2/Home/hero5.jpg",
        },
      ],
    };
  },
  methods: {
    getImage(item) {
      return require(`@/assets/${item.image}`);
    },
  },
};
</script>

<style scoped>
.custom-font {
  font-family: poppins;
}

.btn-gradient-2 {
  background: linear-gradient(black, black) padding-box,
    linear-gradient(to right, #f72f07, #f78b07) border-box;
  border-radius: 1em;
  border: 2px solid transparent;
}


.splash {
  background: black;
}

.splash-content {
  color: white;
  font-size: 3em;
}

.caos-font {
  background: -webkit-linear-gradient(#f72f07, #f78b07);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.fade-in-image {
  /* animation: fadeInOpaque 3s;
  -webkit-animation: fadeInOpaque 3s;
  -moz-animation: fadeInOpaque 3s;
  -o-animation: fadeInOpaque 3s;
  -ms-animation: fadeInOpaque 3s; */
  animation: fadeIn 3s;
  -webkit-animation: fadeIn 3s;
  -moz-animation: fadeIn 3s;
  -o-animation: fadeIn 3s;
  -ms-animation: fadeIn 3s;
}

.fade-in-text {
  animation: fadeIn 3s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

/* @keyframes fadeInOpaque {
  0% { opacity: 0; }
  100% { opacity: 40%; }
}

@-moz-keyframes fadeInOpaque {
  0% { opacity: 0; }
  100% { opacity: 40%; }
}

@-webkit-keyframes fadeInOpaque {
  0% { opacity: 0; }
  100% { opacity: 40%; }
}

@-o-keyframes fadeInOpaque {
  0% { opacity: 0; }
  100% { opacity: 40%; }
}

@-ms-keyframes fadeInOpaque {
  0% { opacity: 0; }
  100% { opacity: 40%; }
} */</style>
